import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=72fc2562&scoped=true"
import script from "./Warehouse.vue?vue&type=script&lang=js"
export * from "./Warehouse.vue?vue&type=script&lang=js"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=72fc2562&prod&scoped=true&lang=scss"
import style1 from "./Warehouse.vue?vue&type=style&index=1&id=72fc2562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc2562",
  null
  
)

export default component.exports